import * as React from "react";
import {Box, Stack, Typography} from "@mui/material";
import SwitchBox from "./SwitchBox";
import {useSurroundings} from "./hooks/useSurroundings";
import {DIGITAL_SPONSOR, ENTOURAGE} from "./constant";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const Switch = () => {
    const {surroundings} = useSurroundings();
    const {mode} = useDarkMode();
    return (
        <Box sx={{backgroundColor:mode.settings.cardBackgroundColor, borderRadius:1, padding:'20px'}}>
            <Stack flexWrap={"wrap"}>
                <Stack flexWrap={"wrap"}>
                    <Typography variant={'subtitle7'} color={mode.settings.textColor3}>Comptes affiliés</Typography>
                    <Typography variant={'h4'} color={mode.settings.textColor3}>
                        Les comptes pour lesquels vous avez été nommé Entourage ou Parrain digital
                    </Typography>
                </Stack>
                <br/>
                {
                    surroundings.findIndex(obj => obj['type'] === ENTOURAGE) !== -1 &&
                    <Typography variant={'subtitle2'} color={mode.settings.textColor4}>Entourage</Typography>
                }

                <Stack direction={'row'} justifyContent={"space-between"} flexWrap={'wrap'}>
                    {
                        surroundings.map((surrounding, index) => (
                            surrounding.type ===  ENTOURAGE && <SwitchBox
                                mail={surrounding.email}
                                name={surrounding.firstname + " " +surrounding.name}
                                canSwitch={false}
                            />
                        ))
                    }
                </Stack>
                <br/>
                {
                    surroundings.findIndex(obj => obj['type'] === DIGITAL_SPONSOR) !== -1 &&
                    <Typography variant={'subtitle2'} color={mode.settings.textColor4}>Parrain</Typography>
                }
                <Stack direction={'row'} justifyContent={"space-between"} flexWrap={'wrap'}>
                    {
                        surroundings.map((surrounding, index) => (
                            surrounding.type ===  DIGITAL_SPONSOR && <SwitchBox
                                mail={surrounding.email}
                                name={surrounding.firstname + " " +surrounding.name}
                                canSwitch={true}
                            />
                        ))
                    }
                </Stack>
                <br/>
            </Stack>
        </Box>
    )
}

export default Switch;

